/** @format */

const IntroTranslations = {
  en: {
    'Intro.titolo':
      'With WeMi access to the system of home services of the municipality of Milan is simpler and faster.',
    'Intro.sottotitolo':
      'If you need help here you can find all the services for the care and wellness offered by social enterprises and cooperatives accredited by the municipality of Milan: all this that can help families care for their children or non self-sufficient people, in the management of the home, pets and much more.',
  },
  it: {
    'Intro.titolo':
      "Con WeMi l'accesso al sistema dei servizi domiciliari del comune di Milano è più semplice e veloce.",
    'Intro.sottotitolo':
      'Se ti serve aiuto qui potrai trovare tutti i servizi per la cura e il benessere offerti dalle imprese sociali e dalle cooperative accreditate dal comune di Milano: tutto ciò che può aiutare le famiglie per la cura dei figli o delle persone non autosufficienti, nella gestione della casa, degli animali domestici e molto altro.',
  },
};

export default IntroTranslations;
